export enum TagType {
  CLICKABLE = 'clickable',
  DEFAULT = 'default',
  DISMISSABLE = 'dismissable',
}

export enum TagColor {
  DANGER = 'danger',
  DANGER_LIGHT = 'danger-light',
  DARK_GREEN = 'dark-green',
  LIGHT = 'light',
  MID = 'mid',
  MID_LIGHT = 'mid-light',
  PREFERRED_FREELANCER = 'preferred-freelancer',
  PREFERRED_FREELANCER_LIGHT = 'preferred-freelancer-light',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SECONDARY_DARK = 'secondary-dark',
  SUCCESS = 'success',
  SUCCESS_LIGHT = 'success-light',
  YELLOW_LIGHT = 'yellow-light',
  INHERIT = 'inherit',
}

export enum TagSize {
  LARGE = 'large',
  MID = 'mid',
  SMALL = 'small',
}
